import { apiMenuTree, apiPermissionTree, MenuItemProps, MenuTreeItemProps } from "apis";
import { lazy, useEffect } from "react";
import { Outlet, useSearchParams } from "react-router-dom";
import useAppSelector from "hooks/useAppSelector";
import { useDispatch } from "react-redux";
import { onSelected } from "store/menu";


export const PageAdminMenu = lazy(() => import("./List"));
export const PageAdminMenuCreate = lazy(() => import("./Add"));
export const PageAdminMenuUpdate = lazy(() => import("./Edit"));

export interface FormMenuValuesProps extends MenuItemProps {
    parentId?: number;
    permissionId?: number;
}

export const PageAdminMenuContainer = () => {
    const [searchParams] = useSearchParams();
    const menu = useAppSelector(state => state.menu);
    const dispatch = useDispatch();

    useEffect(() => {
        apiMenuTree();
        apiPermissionTree();
    }, [])


    function findMenuById(
        data: MenuTreeItemProps[],
        id: number
    ): MenuTreeItemProps | null {
        for (const item of data) {
            if (item.id === id) {
                return item;
            }

            if (item.children?.length) {
                const found = findMenuById(item.children, id);
                if (found) return found;
            }
        }

        return null;
    }

    const _pId = searchParams.get("parentId");
    const pId = _pId && !isNaN(parseInt(_pId)) ? parseInt(_pId) : undefined;

    useEffect(() => {
        const p = findMenuById(menu.tree.data, pId || -1);
        if (p) {
            dispatch(onSelected({ item: p }));
        }
        else {

            dispatch(onSelected({}));
        }
    }, [pId, menu.tree.data])

    return <Outlet />
}